import { cn } from "@/lib/utils";

interface BrandProps {
  /** Mark only, for the collapsed sidebar rail. */
  compact?: boolean;
  /** Renders the wordmark in white, for dark contexts. */
  onNavy?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const LOGO_SIZE = { sm: "h-7 w-7", md: "h-9 w-9", lg: "h-11 w-11" } as const;

export function YkkbiLogoImage({
  size = "md",
  className,
}: {
  size?: "sm" | "md" | "lg";
  className?: string;
}) {
  return (
    <img
      src="/brand/ykkbi-mark.png"
      alt="Logo YKKBI"
      className={cn("shrink-0 select-none object-contain rounded-full", LOGO_SIZE[size], className)}
    />
  );
}

export function Brand({ compact = false, onNavy = false, size = "md", className }: BrandProps) {
  return (
    <div className={cn("flex items-center gap-3 select-none", className)}>
      <YkkbiLogoImage size={size} />
      {!compact && (
        <span className="leading-tight">
          <span
            className={cn(
              "block text-[15px] font-bold tracking-tight",
              onNavy ? "text-white" : "text-[#101828]"
            )}
          >
            YKKBI
          </span>
          <span
            className={cn(
              "block text-[11.5px] font-normal",
              onNavy ? "text-white/60" : "text-[#667085]"
            )}
          >
            Konsol OTA
          </span>
        </span>
      )}
    </div>
  );
}
